import { render, staticRenderFns } from "./VideoBox.vue?vue&type=template&id=83729740&"
import script from "./VideoBox.vue?vue&type=script&lang=js&"
export * from "./VideoBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports